import { OverviewMarket } from '../../../dto';
import { indexById } from '../../indexingUtils';
import { Map } from 'immutable';

export const onOverviewMarketsSnapshot = (markets: OverviewMarket[]) => {
    return (db: Map<string, any>) => db.setIn(['markets'], indexById(markets));
};
